@if (loading()) {
  <p>{{ 'CLIENT.CABINET.ITEM_CATALOG.LOADING' | translate }}</p>
} @else if (items().length === 0) {
  <p class="item-selection-chips__hint">
    {{ 'CLIENT.CABINET.ITEM_CATALOG.NO_SELECTED' | translate }}
  </p>
} @else {
  <section class="item-selection-chips">
    <h2 class="item-selection-chips__title">
      {{ 'CLIENT.CABINET.ITEM_CATALOG.SELECTED_TITLE' | translate }}
    </h2>
    <ul class="item-selection-chips__list">
      @for (item of items(); track item.id) {
        <li class="item-selection-chips__chip">
          <span>{{ item.name }}</span>
          @if (removable()) {
            <button
              type="button"
              class="item-selection-chips__remove"
              [attr.aria-label]="
                'CLIENT.CABINET.ITEM_CATALOG.REMOVE_SELECTED' | translate
              "
              (click)="removeItem(item.id)"
            >
              ×
            </button>
          }
        </li>
      }
    </ul>
  </section>
}
